jQuery(function ($) {
  /**
   * DESKTOP MENU
   */
  $('.navbar.desktop li.has-children').each(function () {
    $(this).mouseenter(function () {
      showDesktopSubmenu($(this).children('.sub-menu'));
    });

    $(this).mouseleave(function () {
      hideDesktopSubmenu($(this).children('.sub-menu'));
    });
  });

  function showDesktopSubmenu(submenu) {
    submenu.fadeIn(100);
  }

  function hideDesktopSubmenu(submenu) {
    submenu.fadeOut(100);
  }

  /**
   * MOBILE MENU
   */
  $('#burger-toggle, #navbar-overlay').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var isOpen = $('#burger-toggle').hasClass('menu-open');

    if (isOpen) {
      hideMobileMenu();
    } else {
      showMobileMenu();
    }
  });

  $('.navbar.mobile li.has-children').each(function () {
    $(this).click(function (e) {
      if ($(this).hasClass('open')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      $(this).addClass('open');
      var mobileSubmenu = $(this).children('.sub-menu');
      mobileSubmenu.fadeIn(100);
    });
  });

  function showMobileMenu() {
    $('#navbar-overlay').show();
    $('.navbar.mobile').show();
    $('.navbar.mobile').animate({ right: '20%' }, 300);
    $('#burger-toggle').addClass('menu-open');
    $(document.body).addClass('menu-open');
  }

  function hideMobileMenu() {
    $('#burger-toggle').removeClass('menu-open');
    $('#navbar-overlay').hide();
    $('.navbar.mobile').animate(
      { right: '100%' },
      {
        duration: 300,
        complete: function () {
          $('.navbar.mobile').hide();
          $(document.body).removeClass('menu-open');
        },
      }
    );
    $('.navbar.mobile li.has-children').each(function () {
      $(this).removeClass('open');
      $(this).children('.sub-menu').fadeOut();
    });
  }
});
